import { render, staticRenderFns } from "./DialogConfirmarAlterarEmail.vue?vue&type=template&id=b086c036&scoped=true&"
import script from "./DialogConfirmarAlterarEmail.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmarAlterarEmail.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmarAlterarEmail.vue?vue&type=style&index=0&id=b086c036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b086c036",
  null
  
)

export default component.exports